import { Box, Divider, Text } from '@chakra-ui/react';
import ExtraServicesList from 'pages/PageExtraServices/components/ExtraServicesList';
import { useTranslation } from 'react-i18next';

const SummaryExtraServices = () => {
  const { t } = useTranslation();
  return (
    <Box position="relative">
      <Divider my={4} />
      <Text fontWeight={600} mb={{ sm: 4, md: 0 }} fontSize="xl">
        {t('summary.extraServices.title')}
      </Text>
      <Divider my={4} display={{ sm: 'none', md: 'block' }} />
      <ExtraServicesList px={0} />
      <Divider my={6} />
    </Box>
  );
};

export default SummaryExtraServices;
